import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {
    TableBodyCell,
    TableBodyRow,
    TableHeader,
    TableHeaderCell,
    TableHeaderCellLabel
} from '@/components/ui/table-atoms/TableAtoms'
import {useTranslation} from '@/translations/i18n'
import {
    StyledBulkSiarExportPreviewSkeletonBody,
    StyledBulkSiarExportPreviewTableInner,
    StyledBulkSiarExportPreviewTableWrapper
} from '@/features/projects/siar-bulk-export/components/bulk-siar-export-dialog/style'

const SKELETON_ROW_COUNT = 8

const COLUMN_SIZES = {
    select: 40,
    projectCode: 100,
    patientFullName: 160,
    startDate: 100,
    expirationDate: 100,
    endDate: 110,
    progressStatus: 110
} as const

const SkeletonRow = () => (
    <TableBodyRow isSelected={false}>
        <Flexbox fullWidth>
            <TableBodyCell cellSize={COLUMN_SIZES.select}>
                <Skeleton width={18} height={18} />
            </TableBodyCell>
            <TableBodyCell cellSize={COLUMN_SIZES.projectCode}>
                <Skeleton width="70%" height={14} />
            </TableBodyCell>
            <TableBodyCell cellSize={COLUMN_SIZES.patientFullName}>
                <Skeleton width="80%" height={14} />
            </TableBodyCell>
            <TableBodyCell cellSize={COLUMN_SIZES.startDate}>
                <Skeleton width="60%" height={14} />
            </TableBodyCell>
            <TableBodyCell cellSize={COLUMN_SIZES.expirationDate}>
                <Skeleton width="60%" height={14} />
            </TableBodyCell>
            <TableBodyCell cellSize={COLUMN_SIZES.endDate}>
                <Skeleton width="60%" height={14} />
            </TableBodyCell>
            <TableBodyCell cellSize={COLUMN_SIZES.progressStatus}>
                <Skeleton width={90} height={20} />
            </TableBodyCell>
        </Flexbox>
    </TableBodyRow>
)

export const BulkSiarExportPreviewTableSkeleton = () => {
    const {t} = useTranslation()

    return (
        <StyledBulkSiarExportPreviewTableWrapper>
            <StyledBulkSiarExportPreviewTableInner>
                <TableHeader>
                    <TableHeaderCell cellSize={COLUMN_SIZES.select} isPinned={false}>
                        <TableHeaderCellLabel />
                    </TableHeaderCell>
                    <TableHeaderCell cellSize={COLUMN_SIZES.projectCode} isPinned={false}>
                        <TableHeaderCellLabel>{t('projects:bulk_siar_export_column_pri_code')}</TableHeaderCellLabel>
                    </TableHeaderCell>
                    <TableHeaderCell cellSize={COLUMN_SIZES.patientFullName} isPinned={false}>
                        <TableHeaderCellLabel>{t('projects:bulk_siar_export_column_patient')}</TableHeaderCellLabel>
                    </TableHeaderCell>
                    <TableHeaderCell cellSize={COLUMN_SIZES.startDate} isPinned={false}>
                        <TableHeaderCellLabel>{t('projects:start_date')}</TableHeaderCellLabel>
                    </TableHeaderCell>
                    <TableHeaderCell cellSize={COLUMN_SIZES.expirationDate} isPinned={false}>
                        <TableHeaderCellLabel>{t('projects:bulk_siar_export_column_expiration')}</TableHeaderCellLabel>
                    </TableHeaderCell>
                    <TableHeaderCell cellSize={COLUMN_SIZES.endDate} isPinned={false}>
                        <TableHeaderCellLabel>{t('projects:bulk_siar_export_column_end_date')}</TableHeaderCellLabel>
                    </TableHeaderCell>
                    <TableHeaderCell cellSize={COLUMN_SIZES.progressStatus} isPinned={false}>
                        <TableHeaderCellLabel>{t('projects:bulk_siar_export_column_status')}</TableHeaderCellLabel>
                    </TableHeaderCell>
                </TableHeader>
                <StyledBulkSiarExportPreviewSkeletonBody>
                    {Array.from({length: SKELETON_ROW_COUNT}).map((_, index) => (
                        <SkeletonRow key={index} />
                    ))}
                </StyledBulkSiarExportPreviewSkeletonBody>
            </StyledBulkSiarExportPreviewTableInner>
        </StyledBulkSiarExportPreviewTableWrapper>
    )
}
